import React from 'react';

import PropTypes from 'prop-types';

import VirtualizedList from '@adsk/alloy-react-virtualized-list';

import { defaultSelectBoxRenderer } from '../layout/defaultRenderers';
import SelectBox from '../SelectBox';

/**
 * VirtualizedSelectBox, extends [SelectBox](selectbox) to add virtualized support
 */
class VirtualizedSelectBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuHeight: props.maxMenuHeight,
    };

    this.menuRenderer = this.menuRenderer.bind(this);
    this.maybeUpdateMenuHeight = this.maybeUpdateMenuHeight.bind(this);
  }

  handleUpdateMenuHeight(menuHeight) {
    this.setState({
      menuHeight,
    });
  }

  renderList({ items, renderItem }) {
    return (
      <VirtualizedList
        items={items}
        renderItem={renderItem}
        overscanCount={this.props.overscanCount}
        onRowsRendered={this.maybeUpdateMenuHeight}
      />
    );
  }

  componentWillUnmount() {
    this.handleUpdateMenuHeight(this.props.maxMenuHeight);
  }

  maybeUpdateMenuHeight({ cellMesureCacheRef, items }) {
    const height = items.reduce((preHeight, _item, index) => {
      return preHeight + cellMesureCacheRef.current.rowHeight({ index });
    }, 0);

    const menuHeight = Math.min(height, this.props.maxMenuHeight);

    if (menuHeight !== this.state.menuHeight) {
      this.handleUpdateMenuHeight(menuHeight);
    }
  }

  menuRenderer({ items, renderItem }) {
    return (
      <div style={{ height: this.state.menuHeight }}>
        {this.renderList({
          items,
          renderItem,
        })}
      </div>
    );
  }

  render() {
    const { children } = this.props;
    return children({
      ...this.props,
      menuRenderer: this.menuRenderer,
    });
  }
}

VirtualizedSelectBox.defaultProps = {
  ...SelectBox.defaultProps,
  children: defaultSelectBoxRenderer,
  overscanCount: 5,
  maxMenuHeight: 300,
};

VirtualizedSelectBox.propTypes = {
  ...SelectBox.propTypes,
  /**
   * render function
   */
  children: PropTypes.func.isRequired,
  /**
   * overscan count
   */
  overscanCount: PropTypes.number,
  /**
   * The max height of the menu
   */
  maxMenuHeight: PropTypes.number,
};

export default VirtualizedSelectBox;
